import { ApiErrorKey, errorMessages } from "./errorMessages";

interface ErrorWithCode {
  response?: {
    data?: {
      errorCode?: string;
    };
  };
}

export function getErrorMessage(apiKey: ApiErrorKey, error: unknown): string {
  const apiErrorMap = errorMessages[apiKey];
  const errorCode = (error as ErrorWithCode)?.response?.data?.errorCode;

  if (typeof errorCode === "string" && errorCode in apiErrorMap) {
    return apiErrorMap[errorCode as keyof typeof apiErrorMap];
  }

  return apiErrorMap.DEFAULT || "Something went wrong. Please try again later.";
}
